import React from 'react';

const Reference = ({image, name, additionalClass}) =>
  <div className={additionalClass + ' align-self-center w-100'}>
    <img src={image} className="img-fluid" alt={name} />
  </div>

export default Reference;


// WEBPACK FOOTER //
// ./src/components/reference.js